import { Button, Modal } from "antd";
import React, { useEffect, useState } from 'react';
import ActivityBaPingModal from "../../activity/component/activityBaPingModal";
import UpgradeModal from '../upgradeModal';
import queue from './bapingQueue.json';
import settlePng from "./settle_tip.png";
import { useBaPingAPI } from './useBaPingAPI';


// 霸屏的弹窗
// 多个霸屏显示顺序，目前有结算霸屏 > 活动霸屏 > 功能升级霸屏.
export const BaPingModals = props => {
  // 弹窗优先级，以属猪顺序为准
  const [rState, dispatch] = useBaPingAPI(props);
  // 初始化state
  const getInitState = () => {
    return queue.reduce((json = {},item = '') => {
      json[item] = false
      return json;
    },{})
  }
  const [state, setState] = useState(getInitState());
  // setState方法
  const $set = (curState) => {
    if (typeof curState !== 'object') return;
    setState(preState => ({...preState, ...curState}))
  };
  // 监听接口中的变化
  useEffect(_=> {
    // 霸屏优先级展示判断
    const initState = getInitState();
    const stateKey = queue.find(key => rState[key]);
    const state = stateKey ? { ...initState, [stateKey]: true } : initState
    $set(state);
  },[ rState.isApiEnd ]);

  // 全都重置为false
  const resetFalse = () => {
    dispatch({reset:'false'})
  };
  return (
    <div>
      <Modal
        title="通知"
        open={state.jiesuanVisible}
        footer={null}
        maskClosable={false}
        onCancel={_ => {
          resetFalse()
        }}
      >
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center',padding:'0 60px'}}>
          <div style={{textAlign: 'center'}}>
            <img src={settlePng} alt="" style={{width:160,height:160}}/>
            <p style={{fontSize: '16px',fontWeight: 'bold',color: '#666'}}>您有结算单待确认</p>
            <span style={{color: '#999'}}>延迟处理会影响佣金发放的及时性</span>
            <Button type="primary" size="default" style={{width:'150px',marginTop:'20px'}} onClick={_=>{
              props.history.push('/settlement/promotion');
              resetFalse();
            }}>去确认</Button>
          </div>
        </div>
      </Modal>
      <ActivityBaPingModal
        { ...props }
        visible={state.activityVisible}
        onCancel={_=> resetFalse()}
        onOk={_=> resetFalse()}
      />
      <UpgradeModal
        { ...props }
        visible={state.entirelyUpgrade}
        onCancel={_=> resetFalse()}
      />

      {/*<PrivacyModal */}
      {/*  visible={state.privacyVisible}*/}
      {/*  onOk={_=> resetFalse()}*/}
      {/*  onCancel={_=> resetFalse()}*/}
      {/*/>*/}
    </div>
  );
};

